<!-- Enterprise Header Wrapper - renders enterprise-specific header based on context -->
<ng-container [ngSwitch]="enterpriseKey">
    <!-- Redefine Enterprise -->
    <app-redefine-header *ngSwitchCase="'redefine'"></app-redefine-header>

    <!-- Default: ParkUpp header (falls through to standard header) -->
    <ng-container *ngSwitchDefault>
        <!-- Standard ParkUpp header would go here, but we typically use app-header directly -->
    </ng-container>
</ng-container>
